import axios from 'axios';
import uuidv4 from 'uuid/v4';
import retryx from 'retryx';

const RETRY_COUNT = 3;

export default class Request {
	static get STATUS() {
		const status = {
			UNPROCESSING: 0,
			PROCESSING: 1,
			DONE: 2,
			FAIL: -1,
			ABORT: -99,
		};
		return status;
	}

	get isUnProcessing() {
		return this.status === Request.STATUS.UNPROCESSING;
	}

	get isAbort() {
		return this.status == Request.STATUS.ABORT;
	}

	constructor(params, onDone, onFail, onToPromise) {
		this.request_id = uuidv4();
		this.params = params;
		this.status = Request.STATUS.UNPROCESSING;
		this.onDone = onDone;
		this.onFail = onFail;
		this.onToPromise = onToPromise;
	}

	reset() {
		this.status = Request.STATUS.UNPROCESSING;
		return this;
	}

	abort() {
		this.status = Request.STATUS.ABORT;
		return this;
	}

	async toPromise() {
		if (this.isAbort)
			return this;

		return retryx(async () => {
			if(this.onToPromise) {
				if(!(await this.onToPromise(this)))
					return null;
			}
			
			this.status = Request.STATUS.PROCESSING;
			return await axios(this.params)
				.then((res) => {
					if (this.onDone)
						this.onDone(res);
					this.status = Request.STATUS.DONE;
					
					return this;
				});
		},{
			maxTries: RETRY_COUNT,
			retryCondition: (tries, reason) =>{
				if(!reason.response) 
					return true;
				
				let ret = true;
				switch (reason.response.status) {
				case 400: // パラメータエラー
				case 404: // リソースエラー
				case 409: // DataSetID照合エラー
					ret = false;
					break;
				case 500: // サーバエラー
					ret = false;
					break;
				case 401: // 認証エラー
				default:
					ret = true;
					break;
				}
				return ret;
			},
		})
		.catch((err) => {
			if (this.onFail)
				this.onFail(err);
			this.status = Request.STATUS.FAIL;
			
			return err;
		});
	}
}
